import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { ElementoBase } from '@/enum/elemento_base';
import { Modules } from '@/enum/modules';
// import request_elemento_tinta_model from '@/views/requests/models/request_elemento_tinta_model'
// import prices_elemento_tinta_model from '@/views/prices/models/prices_elemento_tinta_model'
// import work_order_elemento_tinta_model from '@/views/work_orders/models/work_order_elemento_tinta_model'
// import technical_specification_elemento_tinta_model from '@/views/technical_specifications/models/technical_specification_elemento_tinta_model'
import { useElementoBaseStore } from '../../stores/elemento_base/elemento_base_store';

// Propiedades por defecto del componente InputSuaje
export const InputSuajeDefault = {
  // Props booleanos
  mostrarBotonBuscarSuaje: true,
  mostrarUnidadMedida: true,
  mostrarBotonEngranaje: true,
  mostrarEngranaje: true,
  mostrarDesarrollo: true,
  mostrarCilindro: true,
  mostrarCantidadCilindro: true,
  mostrarCantidadMagneticos: true,
  mostrarMedidaEje: true,
  mostrarMedidaDesarrollo: true,
  mostrarGapEje: true,
  mostrarGapDesarrollo: true,
  mostrarEtiquetasAncho: true,
  mostrarEtiquetasDesarrollo: true,
  mostrarForma: true,
  mostrarLaterales: true,
  mostrarMargenSuperior: false,
  mostrarAnchoMinimo: true,
  mostrarAnchoMaterial: true,
  mostrarPaginas: false,
  mostrarVistaImposicion: true,
  mostrarSellado: false,
  mostrarSolapa: false,
  mostrarBase: false,
  mostrarAltoTotal: false,
  mostrarAnchoTotal: false,
  mostrarDescripcionFormula: false,
  mostrarCantidadColoresFrente: false,
  mostrarCantidadColoresLiner: false,
  mostrarCantidadColoresAdhesivo: false,
  mostrarCantidadCambios: false,

  // Props de etiquetas
  labelTituloSeccion: 'Suaje',
  labelBuscarSuaje: 'Buscar suaje',
  labelUnidadMedida: 'Unidad medida',
  labelBotonEngranaje: 'Nueva Imposicion',
  labelCantidadCilindros: 'Cantidad de cilindros',
  labelCantidadMagneticos: 'Cantidad de magnéticos',
  labelMedidaEje: 'Medida al eje',
  labelMedidaDesarrollo: 'Medida al desarrollo',
  labelGapAlEje: 'Gap al Eje',
  labelGapAlDesarrollo: 'Gap al Des.',
  labelEtiquetasAncho: 'Cavidades en Ancho',
  labelEtiquetasDesarrollo: 'Cavidades en Desarrollo',
  labelLaterales: 'Laterales',
  labelForma: 'Forma suaje',
  labelMargenSuperior: 'Margen superior',
  labelAnchoMinimo: 'Ancho mínimo',
  labelAnchoMaterial: 'Ancho Material',
  labelPaginas: 'Páginas',
  labelSellado: 'Sellado',
  labelSolapa: 'Solapa',
  labelBase: 'Base',
  labelAltoTotal: 'Alto Total',
  labelAnchoTotal: 'Ancho Total',
  labelDescripcionFormula: 'Descripción de fórmula',
  labelCantidadColoresFrente: 'Cantidad de colores frente',
  labelCantidadColoresLiner: 'Cantidad de colores liner',
  labelCantidadColoresAdhesivo: 'Cantidad de colores adhesivo',
  labelCantidadCambios: 'Cantidad de cambios',
};

// const InputSuajeExtrusion = {
//     ...InputSuajeDefault,
//     mostrarBotonBuscarSuaje: false,
//     mostrarLaterales: false,
//     mostrarEngranaje: false,
//     mostrarCilindro: false,
//     mostrarCantidadCilindro: false,
//     mostrarCantidadMagneticos: false,
//     mostrarBotonEngranaje: false,
//     mostrarMargenSuperior: false,
//     mostrarAnchoMinimo: false,
//     mostrarAnchoMaterial: false,
//     mostrarVistaImposicion: false,
//     mostrarEtiquetasAncho: false,
//     mostrarEtiquetasDesarrollo: false,
//     mostrarUnidadMedida: false,
// }

const InputSuajeExtrusion = {};

export const elementoBaseConfig = {
  [ElementoBase.ETIQUETA]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      InputFamiliaMaterial: {},
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },

      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
  },
  [ElementoBase.TERMO_ENCOGIBLE]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarForma: false,
        mostrarVistaImposicion: false,
      },
      InputFamiliaMaterial: false,
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },
  [ElementoBase.FLEXIBLE]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      InputFamiliaMaterial: false,
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarForma: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },
  [ElementoBase.CONSUMIBLE]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarGapEje: false,
        mostrarGapDesarrollo: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      InputFamiliaMaterial: false,
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarGapEje: false,
        mostrarGapDesarrollo: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarGapEje: false,
        mostrarGapDesarrollo: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarGapEje: false,
        mostrarGapDesarrollo: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },

  [ElementoBase.CAJA]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarForma: false,
        mostrarVistaImposicion: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      InputFamiliaMaterial: false,
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },

  [ElementoBase.LIBRO_INTERNO]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      InputFamiliaMaterial: {},
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarPaginas: true,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarPaginas: true,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
  },

  [ElementoBase.LIBRO_TAPA]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      InputFamiliaMaterial: {},
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarVistaImposicion: false,
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
  },

  [ElementoBase.EXTRUSION]: {
    [Modules.SOLICITUD]: {
      InputSuaje: false,
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: false,
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: false,
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: false,
      InputFamiliaMaterial: {},
      InputProcesos: {},
    },
  },

  [ElementoBase.BOLSAS_FUELLE]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAltoTotal: true,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoTotal: true,
        mostrarBase: true,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarCilindro: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarLaterales: false,
        mostrarMargenSuperior: false,
        mostrarVistaImposicion: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAltoTotal: true,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoTotal: true,
        mostrarBase: true,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarCilindro: false,
        mostrarEngranaje: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarLaterales: false,
        mostrarSolapa: true,
        mostrarVistaImposicion: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAltoTotal: true,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoTotal: true,
        mostrarBase: true,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarCilindro: false,
        mostrarEngranaje: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarLaterales: false,
        mostrarSolapa: true,
        mostrarVistaImposicion: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAltoTotal: true,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoTotal: true,
        mostrarBase: true,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarCilindro: false,
        mostrarEngranaje: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarLaterales: false,
        mostrarSolapa: true,
        mostrarVistaImposicion: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },

  [ElementoBase.BOLSAS_BOX]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarCilindro: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarLaterales: false,
        mostrarMargenSuperior: false,
        mostrarVistaImposicion: false,
        mostrarSellado: true,
        mostrarBase: true,
        mostrarAltoTotal: true,
        mostrarAnchoTotal: true,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarBotonBuscarSuaje: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarVistaImposicion: false,
        mostrarSellado: true,
        mostrarSolapa: true,
        mostrarBase: true,
        mostrarAltoTotal: true,
        mostrarAnchoTotal: true,
        mostrarLaterales: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarBotonBuscarSuaje: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarVistaImposicion: false,
        mostrarSellado: true,
        mostrarSolapa: true,
        mostrarBase: true,
        mostrarAltoTotal: true,
        mostrarAnchoTotal: true,
        mostrarLaterales: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarAnchoMaterial: false,
        mostrarAnchoMinimo: false,
        mostrarBotonBuscarSuaje: false,
        mostrarEtiquetasAncho: false,
        mostrarEtiquetasDesarrollo: false,
        mostrarForma: false,
        mostrarGapDesarrollo: false,
        mostrarGapEje: false,
        mostrarVistaImposicion: false,
        mostrarSellado: true,
        mostrarSolapa: true,
        mostrarBase: true,
        mostrarAltoTotal: true,
        mostrarAnchoTotal: true,
        mostrarLaterales: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Alto',
      },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },

  [ElementoBase.OFFSET]: {
    [Modules.SOLICITUD]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarBotonBuscarSuaje: false,
        mostrarLaterales: false,
        mostrarEngranaje: false,
        mostrarDesarrollo: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarBotonEngranaje: false,
        mostrarMargenSuperior: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        mostrarForma: false,
        mostrarVistaImposicion: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      InputFamiliaMaterial: false,
      // InputTintas: {
      //   tintaModelo: {
      //     ...request_elemento_tinta_model,
      //   },
      // },
      InputProcesos: {},
    },
    [Modules.COTIZACION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarDesarrollo: false,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...prices_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ORDEN_PRODUCCION]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarDesarrollo: false,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...work_order_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
    [Modules.ESPECIFICACION_TECNICA]: {
      InputSuaje: {
        ...InputSuajeDefault,
        mostrarDesarrollo: false,
        mostrarForma: false,
        mostrarBotonBuscarSuaje: false,
        mostrarBotonEngranaje: false,
        mostrarCilindro: false,
        mostrarCantidadCilindro: false,
        mostrarCantidadMagneticos: false,
        mostrarLaterales: false,
        mostrarAnchoMinimo: false,
        mostrarAnchoMaterial: false,
        labelMedidaEje: 'Ancho',
        labelMedidaDesarrollo: 'Largo',
        labelGapAlEje: 'Gap Ancho',
        labelGapAlDesarrollo: 'Gap Largo',
        labelEtiquetasAncho: 'Rep. en Ancho',
        labelEtiquetasDesarrollo: 'Rep. en Largo',
      },
      // InputTintas: {
      //   tintaModelo: {
      //     ...technical_specification_elemento_tinta_model,
      //   },
      // },
      InputFamiliaMaterial: false,
      InputProcesos: {},
    },
  },
};

const HeaderDefault = {
  mostrarDescripcionFormula: false,
  labelDescripcionFormula: 'Descripción de fórmula',
};

export function useComponentsProps(elementoBase, modulo) {
  const componentsProps = ref(
    elementoBaseConfig[elementoBase]?.[modulo] ?? {
      InputSuaje: { ...InputSuajeDefault },
      InputTintas: {},
      InputFamiliaMaterial: {},
      InputProcesos: {},
      Header: { ...HeaderDefault },
    },
  );

  const loadConfig = async () => {
    try {
      const elementoBaseStore = useElementoBaseStore();
      const { elementoBaseConfig: elementoBaseConfigStore } = storeToRefs(elementoBaseStore);
      const { campos, etiquetas } = elementoBaseConfigStore.value;

      const baseConfig = elementoBaseConfig[elementoBase]?.[modulo] ?? {};
      const baseInputSuaje = baseConfig.InputSuaje ?? {};
      const baseInputTintas = baseConfig.InputTintas ?? {};

      let inputSuajeProps = {
        ...InputSuajeDefault,
        ...baseInputSuaje,
      };

      if (campos) {
        inputSuajeProps = { ...inputSuajeProps, ...campos };
      }

      if (etiquetas) {
        inputSuajeProps = { ...inputSuajeProps, ...etiquetas };
      }

      const headerProps = {
        ...HeaderDefault,
        mostrarDescripcionFormula:
          campos?.mostrarDescripcionFormula ?? HeaderDefault.mostrarDescripcionFormula,
        labelDescripcionFormula:
          etiquetas?.labelDescripcionFormula ?? HeaderDefault.labelDescripcionFormula,
      };

      componentsProps.value = {
        ...baseConfig,
        InputSuaje: inputSuajeProps,
        Header: headerProps,
      };
    } catch (error) {
      console.error('[useComponentsProps] Error cargando config elemento base', error);
    }
  };

  loadConfig();

  return {
    componentsProps,
  };
}
